(function($, undefined) {
	'use strict';
	var isLocal = window.location.hostname === "localhost";
	var isDev = isLocal || window.location.hostname.includes("dev") || /\b\w+-d\./.test(window.location.hostname);
	var UPLOAD_KEY = isDev ? "dev-location-data/" : "location-data/";

	function isSM() {
		return $('.is-sm-div').css('visibility') === 'visible'; 
	}
	function isXS() {
		return $('.is-xs-div').css('visibility') === 'visible'; 
	}
	function isIP() {
		return $('.is-ip-div').css('visibility') === 'visible'; 
	}
	function stopPropagation(event) {
		event.stopPropagation();
	}
	function removeAllDataAttributes(element) {
		for (var i in element.data()) {
			element.removeAttr('data-' + camelToKebab(i));
		}
	}
	function camelToKebab(string) {
		return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	function getCurrentLang() {
		return $('html').attr('lang');
	}
	function getViewportState() {
		if (isIP()) {
			return "ip";
		}	
		else if (isXS()) {
			return "xs";
		}
		else if (isSM()) {
			return "sm";
		}
		else {
			return "desktop";
		}
	}
	
	function toggleScroll () {
		var diff;
		
		if ($('body').hasClass('no-scroll') || $('html').hasClass('no-scroll')) {
			$('body').removeClass('no-scroll');
			$('html').removeClass('no-scroll');
			diff = 0;
		} else {
			var w1 = $(window).width();
			$('body').addClass('no-scroll');
			$('html').addClass('no-scroll');
			var w2 = $(window).width();
			diff = w2 - w1;
		}
		
		changeScrollDiff(diff);
	}
	function changeScrollDiff (diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	}
	
	/**
	 * Redirect to pageUrl by constructing the new url.
	 * @param pageUrl   the url of the page to redirect to, starting after domain name. e.g. "/my-page"
	 */
	function redirectTo(pageUrl) {
		pageUrl = pageUrl[0] !== '/' ? '/' + pageUrl : pageUrl;
		var currentHref = location.href;
		var currentPath = location.pathname;
		var baseHref = currentHref.substr(0, currentHref.indexOf(currentPath));
		
		location.href = baseHref + pageUrl;
	}
	
	function sendEmail(email, subject, message, file, fields, callback = () => {}) {
		var params = {
			email: email,
			subject: subject,
			file: file,
		};
		if (message) {
			params.message = message;
		}
		for (var key in fields) {
			if (fields.hasOwnProperty(key) && /^field[123456]$/.test(key)) {
				params[key] = fields[key];
			}
		}
		$.ajax({
			url: "/action/sendEmail",
			method: "post",
			data: params,
			complete: function(response) {
				callback(response.responseText);
			}
		});
	}
	
	function saveSessionVariable(key, value, reload) {
		var params = {
			key: key
		};
		if (value) {
			params.value = value;
		}
		$.ajax({
			url: "/action/sessionVariables",
			method: "post",
			data: params,
			complete: function(response) {
				console.log(response.responseText);
				
				if (reload) {
					location.reload();
				}
			}
		});
	}
	
	function addOrReplaceParam(param, value, replaceHistory = true, currentHref = location.href) {
		var params = currentHref.indexOf('?') !== -1 ? currentHref.split('?')[1] : "";
		var paramsArray = params.indexOf('&') !== -1 ? params.split('&') : params.length > 0 ? [params] : [];
		
		var found = false;
		var newParams = "";
		if (paramsArray.length > 0) {
			newParams = paramsArray.map(function(p) {
				var key = p.indexOf('=') !== -1 ? p.split('=')[0] : p;
				if (key == param) {
					found = true;
					return (key + "=" + value);
				}
				return p;
			}).join('&');
			newParams = '?' + newParams;
		}
		
		if (!found) {
			var sep = paramsArray.length > 0 ? '&' : '?';	
			newParams += sep + param + "=" + value;
		}
		if (replaceHistory) {
			history.replaceState({}, document.title, currentHref.split('?')[0] + newParams);
		}
		else {
			return currentHref.split('?')[0] + newParams;
		}
	}
	
	function uploadCroppedImage (file, directory, customLabel = "media", callback = () => {}) {
		if (file !== undefined) {	
			var data = new FormData();
			data.append('image', file);
			data.append('directory', directory);
			data.append('ajax', 'true');
			data.append('offsetX', '0');
			data.append('offsetY', '0');
			data.append('center', 'true');
			data.append('customLabel', customLabel);
			
			$.ajax({
				url: '/action/uploadCroppedImage',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				data: data,
				success: function (response) {
					console.log(response);
					var mediaId = response.replace('success?mediaId=', '');
					callback(mediaId);
				}
			});
		}
	}
	
	function uploadSecureFiles(files, callback = () => {}, associatedId = null, associatedString = null, key) {
		if (files !== undefined && files.length > 0) {
			var data = new FormData();

			// Append each file with a unique key
			for (var i = 0; i < files.length; i++) {
				data.append('files', files[i]);
			}

			// Always append the ajax flag
			data.append('ajax', 'true');

			// Construct the JSON object for metadata
			const metadata = {
				associatedId: associatedId != null ? associatedId : -1,
				associatedString: associatedString || '',
				key: key
			};

			// Append metadata JSON as a field
			data.append('metadata', JSON.stringify(metadata));

			$.ajax({
				url: '/action/sbHandleFile',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				data: data,
				complete: function (response) {
					callback(JSON.parse(response.responseText));
				}
			});
		} else {
			callback();
		}
	}

	
	function formatNumberToMoney(number) {
		if (isNaN(number)) {
			return null;
		}
		var lang = $("html").attr('lang');
		var moneyString = "";
		
		if (typeof number == "string") {
			number = parseFloat(number);
		}
		
		if (lang !== 'fr') { moneyString += '$'; }
		moneyString += number.toFixed(2);
		if (lang == 'fr') { moneyString += '$'; }
		
		return moneyString;
	}
	
	/**
	 * Data management
	 */
	function getPerson (callback = () => { }) {
		$.ajax({
			url: '/action/getPerson',
			type: 'POST',
			dataType: 'json',
			success: (res) => callback(res),
			error: () => callback({})
		});
	}

	function deletePerson(id, callback = () => {}) {
		var params = {
			ajax: true,
			id: id,
			delete: true
		};
		$.ajax({
			url: "/action/updatePerson",
			method: "post",
			data: params,
			complete: function(response) {
				callback(response.responseText);
			}
		});
	}

	function deleteLocation(id, callback = () => {}) {
		var params = {
			ajax: true,
		};
		
		$.ajax({
			url: `/action/sbDeleteLocation?location=${id}`,
			method: "post",
			data: params,
			complete: function(response) {
				callback(response.responseText);
			}
		});
	}
	
	function deleteGenDatas(ids,callback = () => {}) {
		var action = '/action/manageGenData';
		var params = {
			ajax: true,
			delete: true,
			multiple:"true",
			ids
		};
		
		$.ajax({
			url: action,
			data: params,
			method: "post",
			complete: function(response) {
				callback(response.responseText);
			}
		});
	}

	function deleteGenData(id, callback = () => {}) {
		var action = '/action/manageGenData';
		var params = {
			ajax: true,
			delete: true,
			id: id
		};
		
		$.ajax({
			url: action,
			data: params,
			method: "post",
			complete: function(response) {
				callback(response.responseText);
			}
		});
	}
	
	function duplicateGenData(id, ignore = [],gendataType='', callback = () => {}) {
		fetchGenDatas({ids: id}, ([gendata]) => {
			const data = {
				ajax: true,
			};
			const keysToIgnore = ["id","friendlyUrl", "gallery", ...ignore]
			
			if (gendata && !gendata.hasOwnProperty("id")) {
				callback(-1);
			}

			Object.keys(gendata)
				.filter(k => gendata[k] != null && gendata[k].toString().length != 0 && keysToIgnore.indexOf(k) == -1)
				.forEach(k => data[k] = gendata[k]);
			data["field31"] ="cloned-"+gendata["id"];
			
			if(gendataType=="location"){
				data["clonedLocId"]=id;
			}
			if(gendataType=="checklist")
				data["clonedChecklistId"]=id;

			$.ajax({
				url: '/action/manageGenData',
				data,
				type:'POST',
				complete: (res) => {
					const id = res.responseText.indexOf('success-') ? res.responseText.trim().split('success-')[1] : -1;
					callback(id);
				}
			});
		});
	}

	function updatePersonFields(fields, values, personId, callback = () => {}) {
		var params = {
			ajax: true
		};
		for (let i = 0; i < fields.length; i++) {
			params[fields[i]] = values[i];			
		}
		if (personId) {
			params.id = personId; // otherwise update currently logged Person
		}
		$.ajax({
			url: '/action/updatePerson',
			data: params,
			method: 'POST',
			success: function(response) {
				callback(response);
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
			}
		});
	}
	
	function updateGenDatas(dataJson,callback = () => {}) {
		$.ajax({
			url: '/action/manageGenData?ajax=true&multipleUpdate=true',
			contentType:"application/json",
			data: JSON.stringify(dataJson),
			method: 'POST',
			success: function(response) {
				console.log(response);
				if (response.indexOf('fail') === -1) {
					callback(response);
				}
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
			}
		});
	}

	function updateGenDataFieldsGen(id, fields, values, withlock,callback = () => {}) {
		var params = {
			ajax: true,
			id: id
		};
		for (let i = 0; i < fields.length; i++) {
			params[fields[i]] = values[i];			
		}
		
		$.ajax({
			url: withlock?'/action/manageGenData?withloc=true':'/action/manageGenData',
			data: params,
			method: 'POST',
			success: function(response) {
				console.log(response);
				if (response.indexOf('fail') === -1) {
					callback(response);
				}
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
			}
		});
	}

	function updateGenDataFields(id, fields, values, callback = () => {}) {
		updateGenDataFieldsGen(id,fields,values,false,callback);
	}
	
	function updateItemByType(id, fields, values, type, callback = () => {}) {
		if (type == "person") {
			updatePersonFields(fields, values, id, callback);
		} 
		else if (type == "gendata") {
			updateGenDataFields(id, fields, values, callback);
		} 
		else {
			console.log("Unrecognized type: " + type);
		}
	}

	function deleteItemByType(id, type, callback = () => {}, fields = {}) {
		if (type == "person") {
			deletePerson(id, callback);
		} 
		else if (type == "gendata") {
			if(fields && fields.itemId.indexOf(",")!=-1)
				deleteGenDatas(fields.itemId,callback);
			else deleteGenData(id, callback);
		} 
		else if (type == "location-user") {
			let parent = $(`[data-id="location-editable-item-${id}"]`).closest('.wizard-users-access__users');
			removeItemByDataId("location-editable-item-" + id);
			$('body').trigger("location-user-removed", [id, fields.name, fields.roleText, parent]);
			callback();
		}
		else if (type == "location-contact") {
			removeItemByDataId("location-editable-item-" + id);
			callback();
		}
		else if (type == "location-overview") {
			removeItemByDataId("location-overview-item-" + id);
			callback();
		}
		else if (type == "location-site-plan" || type == "location-document") {
			removeItemByDataId(`${type}-row-${id}`);
			deleteSecureFile(id, callback);
		} else if (type == 'location') {
			deleteLocation(id, callback);
		} else if (type == 'wizard-emergency') {
			removeItemByDataId(`${type}-item`);
			callback();
		} else if (type == 'notification') {
			deleteNotification(id, callback);
		} else {
			console.log("Unrecognized type: " + type);
		}
	}
	
	function deleteNotification(id, callback) {
		removeItemByDataId(`notification-${id}`);
		$.ajax({
			url: '/action/manageGenData',
			type: 'POST',
			data: {
				id,
				ajax: true,
				field8: 'true',
			},
			complete: () => callback()
		});
	}

	function deleteSecureFile(id, callback) {
		$.ajax({
			url: '/action/sbHandleFile?deleteId=' + encodeURIComponent(id),
			type: 'DELETE',
			success: () => callback(),
			error: () => callback(),
		});
	}

	function removeItemByDataId(id) {
		$('[data-id=' + id + ']').remove();
	}
	
	function createPerson(fields, callback = () => {}) {
		fields.ajax = true;
		$.ajax({
			url: "/action/createAccount",
			method: "post",
			data: fields,
			success: function(response) {
				console.log(response);
				if (response.indexOf("success") !== -1) {
					callback(response.trim().split("-")[1]);	
				}
				else {
					callback(-1);
				}
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
				callback(-1);
			}
		});
	}
	
	
	function fetchGenDatas(fields, callback = () => {}) {
		fields.json = true;
		$.ajax({
			url: "/action/fetchGenData",
			method: "get",
			data: fields,
			dataType: 'json',
			success: function(response) {
				if (typeof response === 'string' && response.indexOf('error') != 0) {
					callback([]);
				} else {
					var formattedResponse = Array.isArray(response) ? response : [response];
					callback(formattedResponse);
				}
			},
			error: () => callback([])
		});
	}
	
	var notificationTimeoutIds = {};
	function showGeneralNotification(notifClass) {
		notifClass = notifClass[0] == "." ? notifClass : '.' + notifClass;
		$('.general-notification' + notifClass).addClass('show');
		
		notificationTimeoutIds['.general-notification' + notifClass] = setTimeout(function() {
			$('.general-notification' + notifClass).removeClass('show');
		}, 5000);
	}
	function formatZeros(number, desiredLength = 2) {
	    var numberAsString = number.toString();
	    var numberLength = numberAsString.length;
	    while (numberLength < desiredLength) {
	        numberAsString = "0" + numberAsString;
	        numberLength++;
	    }
	    return numberAsString;
	}
	
	/*
		Date utils
	 */
	function nowDateFormatted() {
	    var date = new Date();
	    var nowFormatted = "";
	    nowFormatted += date.getFullYear() + '-';
	    nowFormatted += formatZeros(date.getMonth() + 1) + '-'; 
	    nowFormatted += formatZeros(date.getDate());
	    return nowFormatted;
	}
	function nowTimeFormatted() {
	    var date = new Date();
	    var nowFormatted = "";
	    nowFormatted += formatZeros(date.getHours()) + ':';
	    nowFormatted += formatZeros(date.getMinutes());
	    return nowFormatted;
	}
	
	function initTinyMCE(target) {
		const options = {
			mode: "specific_textareas",
			language: getCurrentLang(),
			relative_urls: true,
			remove_script_host: true,
			urlconverter_callback: 'customURLConverter',
			allow_script_urls: true,
			convert_urls: true,
			plugins: ["advlist autolink lists link charmap print anchor",
				"searchreplace visualblocks code textcolor",
				"insertdatetime media table contextmenu paste filemanager hr fullscreen"],
			menu: {
				file: { title: 'File', items: 'newdocument print' },
				edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
				insert: { title: 'Insert', items: 'link | charmap anchor hr insertdatetime' },
				view: { title: 'View', items: 'visualblocks visualaid' },
				format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat' },
				table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
				tools: { title: 'Tools', items: 'code' }
			},
			entity_encoding: "numeric",
			force_br_newlines: false,
			contextmenu: "link inserttable | bold italic underline | cell row column deletetable | fontsizeselect",
			toolbar: "undo redo | styleselect fontsizeselect | link | bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent ",
			image_caption: true,
			extended_valid_elements: 'script[language|type|src]',
			fontsize_formats: "12px 13px 14px 15px 16px 18px 20px 22px 24px 28px 30px 32px 36px 40px 50px 60px",
			rel_list: [
				{ title: 'None', value: '' },
				{ title: 'No Follow', value: 'nofollow' }
			]
		};

		if (typeof target === 'string') {
			options.selector = target;
		} else {
			options.target = target;
		}

		tinyMCE.init(options);
	}
	
	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			function later() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}
	
	// https://stackoverflow.com/questions/18123501/replacing-accented-characters-with-plain-ascii-ones
	function removeLowercaseDiacritics(str) {
		var defaultDiacriticsRemovalMap = [
			{'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
			{'base':'aa','letters':/[\uA733]/g},
			{'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
			{'base':'ao','letters':/[\uA735]/g},
			{'base':'au','letters':/[\uA737]/g},
			{'base':'av','letters':/[\uA739\uA73B]/g},
			{'base':'ay','letters':/[\uA73D]/g},
			{'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
			{'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
			{'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
			{'base':'dz','letters':/[\u01F3\u01C6]/g},
			{'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
			{'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
			{'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
			{'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
			{'base':'hv','letters':/[\u0195]/g},
			{'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
			{'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
			{'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
			{'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
			{'base':'lj','letters':/[\u01C9]/g},
			{'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
			{'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
			{'base':'nj','letters':/[\u01CC]/g},
			{'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
			{'base':'oi','letters':/[\u01A3]/g},
			{'base':'ou','letters':/[\u0223]/g},
			{'base':'oo','letters':/[\uA74F]/g},
			{'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
			{'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
			{'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
			{'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
			{'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
			{'base':'tz','letters':/[\uA729]/g},
			{'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
			{'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
			{'base':'vy','letters':/[\uA761]/g},
			{'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
			{'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
			{'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
			{'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
		];
		
		for(var i=0; i<defaultDiacriticsRemovalMap.length; i++) {
			str = str.toLowerCase().replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
		}
		
		return str;
	}
	
	
	function getClosest(element, selector, includeSelf = false) {
		const parent = includeSelf ? element.parentNode : element.parentNode.parentNode;

		if (parent) {
			const elements = parent.querySelectorAll(selector);
			let closest = Array.prototype.filter.call(elements, node => node.contains(element));
			
			if (closest.length) {
				return closest[0];
			} else {
				return getClosest(parent, selector, true);
			}
		} else {
			return null;
		}
	}

	const TOKEN_SIZE_DEFAULT = 10;
	function generateToken(size = TOKEN_SIZE_DEFAULT) {
		let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		let finalSize = isNaN(size) ? TOKEN_SIZE_DEFAULT : size;
		let token = "";

		for(let i = 0; i < finalSize; i++) {
			token += chars[Math.floor(Math.random() * chars.length)];
		}

		return token;
	}

	Fw.component.export('utils', {
		isSM,
		isXS,
		isIP,
		stopPropagation,
		toggleScroll,
		changeScrollDiff,
		redirectTo,
		sendEmail,
		saveSessionVariable,
		addOrReplaceParam,
		uploadCroppedImage,
		uploadSecureFiles,
		formatNumberToMoney,
		removeAllDataAttributes,
		camelToKebab,
		getCurrentLang,
		getPerson,
		deletePerson,
		deleteGenData,
		duplicateGenData,
		deleteItemByType,
		createPerson,
		fetchGenDatas,
		updatePersonFields,
		updateGenDatas,
		updateGenDataFields,
		updateGenDataFieldsGen,
		updateItemByType,
		showGeneralNotification,
		formatZeros,
		nowDateFormatted,
		nowTimeFormatted,
		getViewportState,
		debounce,
		removeLowercaseDiacritics,
		initTinyMCE,
		getClosest,
		generateToken,
		UPLOAD_KEY
	});

})(jQuery);
